module.exports = __webpack_public_path__ + "img/view_2.a2b3e38e.svg";